'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_pages_PrintRecipesPage$State(meals, msgState, showDates) {
  this.wM = null;
  this.zt = null;
  this.wN = false;
  this.wM = meals;
  this.zt = msgState;
  this.wN = showDates;
}
export { $c_Lmealorama_pages_PrintRecipesPage$State as $c_Lmealorama_pages_PrintRecipesPage$State };
$p = $c_Lmealorama_pages_PrintRecipesPage$State.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_pages_PrintRecipesPage$State;
/** @constructor */
function $h_Lmealorama_pages_PrintRecipesPage$State() {
}
export { $h_Lmealorama_pages_PrintRecipesPage$State as $h_Lmealorama_pages_PrintRecipesPage$State };
$h_Lmealorama_pages_PrintRecipesPage$State.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  var acc = (-889275714);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, 80204913);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.wM));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.zt));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, (this.wN ? 1231 : 1237));
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().ax(acc, 3);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lmealorama_pages_PrintRecipesPage$State)) {
    if ((this.wN === x$0.wN)) {
      var x = this.wM;
      var x$2 = x$0.wM;
      var $x_1 = ((x === null) ? (x$2 === null) : x.f(x$2));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$3 = this.zt;
      var x$4 = x$0.zt;
      return ((x$3 === null) ? (x$4 === null) : x$3.f(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().J(this);
});
$p.q = (function() {
  return 3;
});
$p.r = (function() {
  return "State";
});
$p.g = (function(n) {
  switch (n) {
    case 0: {
      return this.wM;
      break;
    }
    case 1: {
      return this.zt;
      break;
    }
    case 2: {
      return this.wN;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__I__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), n);
    }
  }
});
function $isArrayOf_Lmealorama_pages_PrintRecipesPage$State(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.kx)));
}
export { $isArrayOf_Lmealorama_pages_PrintRecipesPage$State as $isArrayOf_Lmealorama_pages_PrintRecipesPage$State };
var $d_Lmealorama_pages_PrintRecipesPage$State = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_pages_PrintRecipesPage$State, "mealorama.pages.PrintRecipesPage$State", ({
  kx: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lmealorama_pages_PrintRecipesPage$State as $d_Lmealorama_pages_PrintRecipesPage$State };
//# sourceMappingURL=mealorama.pages.-Print-Recipes-Page$-State.js.map
